import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { GroupedInvestmentsData } from "screens/investmentsPage/types";

export function useGetSuccessorOwnerInvestments(ownerUuid: string | null) {
  return useQuery({
    queryKey: ["investments/grouped", "successor", ownerUuid],
    queryFn: async () => {
      const res = await axiosInstance.get<GroupedInvestmentsData>(
        `/successors/${ownerUuid}/investments/grouped`
      );
      return res.data;
    },
    enabled: ownerUuid !== null,
    staleTime: 1000 * 30,
    retry: false,
  });
}
